/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  AUTH_CHECK_LOGGED,
  AUTH_FORGOT_LOGIN,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_CHANGE_PASSWORD,
  AUTH_CHANGE_PASSWORD_ERROR,
  VALIDATE_TOKEN_SUCESS,
  AUTH_UPDATE_USER_TOKEN,
  AUTH_CHANGE_USER_CREDENTIAL,
  AUTH_CHANGE_USER_CREDENTIAL_ERROR,
  SUCCESS_FORGOT_PASSWORD,
  SET_CREDENTIALS_ERROR,
  CLEAN_CREDENTIALS_ERROR,
  WARN_LOGIN_ATTEMPTS_ERROR,
} from '~/actions/actionTypes';

const initialState: reducers.AuthReducer = {
  checkLogged: false,
  validateTokenStatus: false,
  authToken: {
    accessToken: null,
    refreshToken: null,
  },
  passwordRecovery: '',
  changePassword: false,
  changePasswordError: false,
  updateUserToken: false,
  changeUserCredential: false,
  changeUserCredentialFail: null,
  loginRecovery: '',
  validateFirstLogin: false,
  firstLogin: false,
  wasSuccessful: false,
  credentialsError: 0,
  showRecoveryPassowordWarnModal: false,
};

const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case AUTH_LOGIN:
      state = {
        ...state,
        authToken: action.payload,
      };
      break;
    case AUTH_CHECK_LOGGED:
      state = {
        ...state,
        checkLogged: true,
      };
      break;
    case AUTH_LOGOUT:
      state = {
        checkLogged: false,
        authToken: {
          accessToken: null,
          refreshToken: null,
        },
        passwordRecovery: '',
        changePassword: false,
        updateUserToken: false,
        changeUserCredential: false,
        changeUserCredentialFail: null,
        validateTokenStatus: false,
        changePasswordError: false,
        loginRecovery: '',
        firstLogin: false,
        validateFirstLogin: false,
        wasSuccessful: false,
        credentialsError: 0,
        showRecoveryPassowordWarnModal: false,
      };
      break;

    case SUCCESS_FORGOT_PASSWORD:
      state = {
        ...state,
        wasSuccessful: action.payload,
      };
      break;

    case AUTH_FORGOT_LOGIN:
      state = {
        ...state,
        loginRecovery: action.payload,
      };
      break;

    case AUTH_CHANGE_PASSWORD:
      state = {
        ...state,
        changePassword: action.payload,
      };
      break;

    case AUTH_CHANGE_PASSWORD_ERROR:
      state = {
        ...state,
        changePasswordError: action.payload,
      };
      break;

    case AUTH_UPDATE_USER_TOKEN:
      state = {
        ...state,
        updateUserToken: action.payload,
      };
      break;

    case VALIDATE_TOKEN_SUCESS:
      state = {
        ...state,
        validateTokenStatus: action.payload,
      };
      break;

    case AUTH_CHANGE_USER_CREDENTIAL:
      state = {
        ...state,
        changeUserCredential: action.payload,
      };
      break;

    case AUTH_CHANGE_USER_CREDENTIAL_ERROR:
      state = {
        ...state,
        changeUserCredentialFail: action.payload,
      };
      break;

    case SET_CREDENTIALS_ERROR:
      state = {
        ...state,
        credentialsError: state.credentialsError + 1,
      };
      break;

    case CLEAN_CREDENTIALS_ERROR:
      state = {
        ...state,
        credentialsError: 0,
      };
      break;

    case WARN_LOGIN_ATTEMPTS_ERROR:
      state = {
        ...state,
        showRecoveryPassowordWarnModal: action.payload,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default authReducer;
